var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPacketContents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F8F3ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4953 5.42129C8.99783 5.5132 8.53409 6.90217 8.48941 7.58516L8.12079 7.69526C8.3659 5.53523 9.80592 4.99841 10.4953 5C12.3671 5.00434 12.7661 6.85589 12.7693 7.69526H12.4485C12.3336 5.79566 11.0985 5.38778 10.4953 5.42129Z",
    fill: "#E89821"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7323 8.22653C6.78592 7.68652 7.43125 7.5579 7.74721 7.56109H13.334C13.7055 7.56109 13.9995 7.72386 14.2101 8.22653L15 13.0043C14.9732 13.483 14.5356 13.6793 14.3202 13.7176H6.7323C6.01228 13.6678 5.95675 12.9947 6.01899 12.6644L6.7323 8.22653Z",
    fill: "#E89821"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketContents);
export default __webpack_public_path__ + "static/media/packetContents.e5e5cf7952aac3abae5999c5cdc57eaf.svg";
export { ForwardRef as ReactComponent };